import { Radio } from "@mui/material";
import React from "react";

export const XGridRadioButton = (checked) => {
  return (
    <Radio checked={checked}></Radio>
  )
}